import axios from "axios";

export default axios.create({
  baseURL: "https://familygm.xyz",
  validateStatus: (status) => status < 500,
});
